/**
 * Created by Neelakandan S.
 */
define(['edge/platform/base/BaseCtrl'], (BaseCtrl)=> {
        
    const fn =($scope, $http, $timeout, $stateParams, $state, submissionViewModel , ModalService, $q, StateUtils, InMemorySession, CustomQuoteService)=> {
        
        const ctrl = Object.create(BaseCtrl);
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        const submissionVM = submissionViewModel();

        const paModel = submissionVM.draftData.lobs.personalAuto.value;
        const accountHolder = submissionVM.value.getAccountHolderPerson();
        
        ctrl.init = ()=> {    
            
            $scope.eSignedPdfUrl = undefined;
           
            $scope.view = submissionVM.draftData.eSignature;
            $scope.retrievedIPAddress = false;

            // Fill static values
            $scope.view.ipAddress.value = "127.0.0.1";
            $scope.view.eSignedName.value = accountHolder.displayName;
            $scope.view.emailAddress.value = accountHolder.emailAddress1;
            $scope.view.quoteNumber.value = submissionVM.quoteID.value;
            
            $scope.servicePointUrl = window.location.origin;
            
            // Set docLoaded as false when controller init; So it will shows the loading animator
            $scope.docLoaded = false;
            
            // Detect IE browser            
            var isIeBrowser = function(){
                var userAgent = window.navigator.userAgent;
                return (userAgent.indexOf("Trident") > -1 || userAgent.indexOf("trident") > -1)
            };
            
            // scope varible to used to apply the css class
            $scope.isIeBrowser =  isIeBrowser();
            console.log("isIeBrowser:: ",$scope.isIeBrowser);

            
            // Increase the height of the gw esign form frame to avoid the overlapping of 
            // iframe over the agreement checkbox.
            //var esignFrame = document.getElementById("gw-esignature-form"); 
            //esignFrame.style.height = "500px";            
                       
            // Check Iframe content:: Timer Function
            // Every 1 second this function will check iframe content is
            // loaded or not. if loaded then timer gets stopped and 
            // loading animator frame will be hidden
            var checkIframe = function(){
                
                var iframe = document.getElementById("qb-esign-form");

                if(iframe == null){
                    $timeout(checkIframe, 1000);
                }
                else{
                    
                    /*var elem = angular.element("#qb-esign-form");
                    console.log("Elem Content: ",elem.contents());
                    
                    var iframeLoaded  = iframe.contentWindow.document.body.innerHTML;
                    if(iframeLoaded == ""){
                        $timeout(checkIframe, 1000);
                    }
                    else{
                        $scope.docLoaded = true;
                        
                        // Reduce the height of the gw esign form frame to its original size  
                        var esignFrame = document.getElementById("gw-esignature-form");
                        esignFrame.style.height = "350px";
                    }*/
                    
                    
                    // For IE browser
                    if (navigator.userAgent.indexOf("Trident") > - 1){
                        $scope.docLoaded = true;
                    }
                    // Other than IE browsers
                    else{

                       iframe.onload = function(){
                            $scope.docLoaded = true;

                            // Reduce the height of the gw esign form frame to its original size  
                            var esignFrame = document.getElementById("gw-esignature-form");
                            esignFrame.style.height = "350px";
                        };
                    }
                }
            };
           
            // Get IP Address from third party service
            $http.get($scope.servicePointUrl+"/pc/service/clientip").then(  
            function(successResponse){
                                
                $scope.retrievedIPAddress = true;
                //formatted ip to get the first ip from array for firewall issue --Arpita
                let rawIP = successResponse.data.ip;
                if(rawIP.length > 50){
                    rawIP = rawIP.substring(0,50);
                }
                if(rawIP.includes(",")){
                    let formattedIp = successResponse.data.ip.split(',')
                    $scope.view.ipAddress.value = formattedIp[0];
                }else{
                    $scope.view.ipAddress.value = rawIP;
                }
                //ended
                var url = $scope.servicePointUrl+"/pc/service/docviewer";
                var pdfurl = url+"?jobNumber="+$scope.view.quoteNumber.value+"&eventName=Quote#toolbar=0";
               //$scope.eSignedPdfUrl = 'http://docs.google.com/gview?url=' + pdfurl + '&embedded=true';
              $scope.eSignedPdfUrl = pdfurl;
            // Init Document Loader Timer
                //$timeout(checkIframe, 1000);
                
            },
            function(failureResponse){
            });
        };
        
        ctrl.isItAgreed = () => { 
            
            if($scope.retrievedIPAddress 
                    && $scope.view.eSignAgreed 
                        && $scope.view.eSignAgreed.value 
                             /*&& $scope.docLoaded*/){ // Enable this check if user wants to wait until the doc loads
                return false;
            }
            
            return true;
        };
        
        /*CustomQuoteService.doEsignature
        
        var ncDescriptionChoices = CustomQuoteService.retrieveVoilationTypes('quoteandbind', {state: "NC"});
        $q.when(ncDescriptionChoices, function(response){
        //console.log("producerCodeSummary:: ", response);
        $scope.ncDescriptions = response.result;
        });*/
        
        ctrl.changeAgreeCondition = () => {
            
            if($scope.view.eSignAgreed.value){
                $scope.view.eSignedDate.value = new Date();
                //console.log("eSignedDate: ",$scope.view.value);
                var eSignReq = CustomQuoteService.doEsignature('quoteandbind', $scope.view.value);
                $q.when(eSignReq, function(response){
                    //console.log("eSignReq:: ", response);
                    //$scope.isValidSign = response.result;
                });
            }            
        };
        
        ctrl.openModalWindow = ()=> {
            //console.log("Open Modal Window!!!");
            ModalService.showEsignAgreementModal();
        };

        ctrl.next = function (form) {
        
            form.submitted = true;
            flowModel.next(submissionVM);
        };

        ctrl.cancel = function () {
            flowModel.cancel(submissionVM);
        };

        return ctrl.create($scope);
    };

    fn.$inject = ['$scope', '$http', '$timeout', '$stateParams', '$state', 'submissionViewModel','ModalService', '$q', 'StateUtils', 'InMemorySession', 'qnb.CustomQuoteService'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/pa/controllers/PAESignatureCtrl.js
 **/